import { render, staticRenderFns } from "./AreaClassifiedSourceTable.vue?vue&type=template&id=50cf18a6&scoped=true&"
import script from "./AreaClassifiedSourceTable.vue?vue&type=script&lang=js&"
export * from "./AreaClassifiedSourceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cf18a6",
  null
  
)

export default component.exports